import { memo } from "react";

const Downloader = () => {
    return <div className="action-show-download-all-spinner hide">
    <span className="loader"></span>
    <span>Download starting, please check your downloads folder once complete</span>
</div>;
}

export default memo(Downloader);